import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { translateName } from '../../functions/language.functions';
import { TranslateService } from '@ngx-translate/core';
import { SearchMode } from './searchmode';
import { SdRegionId, SdRegionListEntry, StammdatenregionService } from '../../../core/stammdaten-api';
import { Subscription } from 'rxjs';
import { NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { AbstractTypeaheadSearch } from '../../components/typeahead-search/abstract-typeahead-search';
import { GbGemeindeSearchMode } from '../gb-gemeinde/gbGemeindeSearchMode';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';

@Component({
  selector: 'cap-regionen',
  templateUrl: './regionen.component.html',
  styleUrls: ['./regionen.component.scss'],
  host: {
    class: 'form-control-component'
  },
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RegionenComponent), multi: true }],
  imports: [FormsModule, NgbTypeahead, MetaDisablerDirective, MetaValidatorDirective]
})
export class RegionenComponent
  extends AbstractTypeaheadSearch<SdRegionListEntry>
  implements OnInit, AfterViewInit, ControlValueAccessor, OnDestroy
{
  @Input()
  searchMode: GbGemeindeSearchMode;

  @Input()
  nurGueltige = true;

  @Input()
  imSeybuch = false;

  @Input()
  showKreisnummer = true;

  @Input()
  hasfocus = false;

  model: SdRegionListEntry;

  propagateChange: (id: SdRegionId) => void;
  propagateTouch: (_) => void;

  private reset = false;
  private subscription: Subscription;

  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  constructor(
    private translate: TranslateService,
    private regionService: StammdatenregionService
  ) {
    super();
  }

  ngOnInit() {
    const findAll = this.regionService.loadRegionListEntriesAll(
      SearchMode[this.searchMode] //
    );
    this.setSearch(findAll);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.hasfocus) {
        this.searchInput.nativeElement.focus();
      }
    });
  }

  writeValue(id: SdRegionId): void {
    if (id) {
      this.subscription = this.regionService.loadRegionListEntryById(id.id).subscribe((region) => {
        this.value = translateName(region.name, this.translate);
        this.selectedItem = region;
        this.model = region;
        this.propagateChange(region.id);
      });
      this.reset = false;
    } else if (!this.reset) {
      this.reset = true;
      this.onClear();
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  onSelected($event: NgbTypeaheadSelectItemEvent<SdRegionListEntry>) {
    const selectedItem: SdRegionListEntry = $event.item;
    if (selectedItem) {
      this.selectedItem = selectedItem;
      this.model = selectedItem;
      this.value = this.formatEntry(selectedItem);
      this.propagateChange(selectedItem.id);
      this.reset = false;
    }
  }

  formatEntry(entry: SdRegionListEntry): string {
    return translateName(entry.name, this.translate);
  }

  onBlur() {
    if (!this.selectedItem) {
      this.value = '';
      this.propagateChange(null);
    }
  }

  public onClear() {
    super.onClear();
    this.model = null;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
